module.exports = __webpack_public_path__ + "static/ICONMESSANGES-08-3107adf6de7f1dbb51648414a598bad4.png";